import React from 'react';

import SuggestedPhoneNumbersTable from '../suggested-phone-numbers-table';

import { getPhoneNumbersLoadingData } from '../../utils/phoneNumberUtils';

interface SuggestedPhoneNumbersTableProps {
  columns: {
    key: string;
    header: string | JSX.Element;
    component: (row: any) => JSX.Element;
  }[];
  tableTitle: JSX.Element;
  cartCount?: number;
}

const SearchingPhoneNumbers: React.FC<SuggestedPhoneNumbersTableProps> = ({
  columns,
  tableTitle,
  cartCount = 0,
}) => {
  const loadingData = getPhoneNumbersLoadingData();

  return (
    <div className="searching-phone-numbers">
      <SuggestedPhoneNumbersTable
        columns={columns}
        data={loadingData}
        tableTitle={tableTitle}
        rowClassName={() => ''}
        tableHeightClassname="purchase-phone-numbers-height"
        className="row-loading"
        cartCount={cartCount}
      />

      <p className="searching-phone-numbers-text">
        Fetching the best available numbers for you——almost there!
      </p>
    </div>
  );
};

export default SearchingPhoneNumbers;
